import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Header from './components/Header9';
import Footer from './components/Footer9';

const FAQs = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: 'What types of products does NAKSHA offer?',
            answer: 'We offer a curated selection of authentic Indian fashion including handloom sarees, silk kurtas, designer lehengas, sherwanis, dupattas, and fusion wear. All our products are sourced directly from artisan communities across India.'
        },
        {
            question: 'How do I determine my size?',
            answer: 'We provide a detailed size chart on each product page. For traditional Indian wear like sarees, standard sizing applies. For stitched garments, refer to our measurement guide. If you need assistance, contact our support team for personalized sizing help.'
        },
        {
            question: 'What is your shipping policy?',
            answer: 'We offer free shipping on orders above \u20B9999. Standard delivery takes 5-7 business days across India. Express shipping (2-3 business days) is available at an additional cost. International shipping is available to select countries.'
        },
        {
            question: 'Can I return or exchange a product?',
            answer: 'Yes, we have a 7-day return and exchange policy. Products must be in their original condition with tags attached. Customized or altered items cannot be returned. Refunds are processed within 7-10 business days after we receive the item.'
        },
        {
            question: 'Are the products authentic handloom?',
            answer: 'Absolutely. We work directly with certified handloom weavers and artisan cooperatives. Each product comes with an authenticity certificate. Our team personally visits artisan clusters to ensure quality and fair trade practices.'
        },
        {
            question: 'What payment methods do you accept?',
            answer: 'We accept all major credit and debit cards (Visa, Mastercard, RuPay), UPI payments (Google Pay, PhonePe, Paytm), net banking, and Cash on Delivery. All online transactions are secured with 256-bit SSL encryption.'
        },
        {
            question: 'How can I track my order?',
            answer: 'Once your order is shipped, you will receive a tracking number via email and SMS. You can track your order in real-time through our Orders page or by using the tracking link provided.'
        },
        {
            question: 'Do you offer customization?',
            answer: 'Yes, select products can be customized for size, color, and embroidery preferences. Customization requests are handled directly with our artisan partners. Please allow an additional 7-14 days for customized orders.'
        },
    ];

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <div className="pt-20 md:pt-24 pb-8 bg-[#F8FAFC] border-b border-[#E2E8F0]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-0.5 bg-[#2563EB]" />
                        <p className="text-xs tracking-[0.3em] uppercase text-[#2563EB] font-medium">Help Center</p>
                    </div>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A]">Frequently Asked Questions</h1>
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                <div className="space-y-3">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`border border-[#E2E8F0] rounded-none overflow-hidden transition-colors duration-300 ${
                                openIndex === index ? 'border-[#2563EB]' : ''
                            }`}
                        >
                            <button
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                className="w-full flex items-center justify-between p-4 sm:p-6 text-left bg-transparent border-none cursor-pointer"
                            >
                                <span className="text-sm sm:text-base font-medium text-[#0F172A] pr-4">{faq.question}</span>
                                {openIndex === index ? (
                                    <ChevronUp size={18} className="text-[#2563EB] flex-shrink-0" />
                                ) : (
                                    <ChevronDown size={18} className="text-[#64748B] flex-shrink-0" />
                                )}
                            </button>
                            {openIndex === index && (
                                <div className="px-4 sm:px-6 pb-4 sm:pb-6 relative">
                                    <div className="absolute top-0 left-0 w-1 h-full bg-[#2563EB]" />
                                    <p className="text-sm text-[#64748B] leading-relaxed font-light pl-4">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="mt-12 text-center p-8 bg-[#F8FAFC] border border-[#E2E8F0] rounded-none">
                    <h3 className="text-lg font-semibold text-[#0F172A] mb-2">Still have questions?</h3>
                    <p className="text-sm text-[#64748B] mb-4 font-light">Our team is here to help you with anything you need.</p>
                    <a href="mailto:hello@naksha.in" className="text-sm font-medium text-[#2563EB] hover:text-[#1D4ED8] transition-colors">
                        hello@naksha.in
                    </a>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default FAQs;
